import { AbstractControl, ValidationErrors } from '@angular/forms';

import * as cpf from 'cpf';

export class CpfValidator {

  static cpfInvalido(ac: AbstractControl): ValidationErrors | null {

    return ac.value && ac.value.length === 14 && !cpf.isValid(ac.value) ? { cpfInvalido: true } : null;

  }

}
